import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_plus",
  "use": "icon_plus-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol viewBox=\"0 0 11 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.9546 5.91793V6.88222H0.0449222L0.0449219 5.91793H10.9546Z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.98189 0.945252L5.98189 11.8549H5.0176L5.0176 0.945251L5.98189 0.945252Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol